import React, { createContext, useState, useContext } from 'react';

const SearchContext = createContext();

export const useSearchContext = () => useContext(SearchContext);

export const SearchProvider = ({ children }) => {
  const [searchTermCtx, setSearchTerm] = useState('');

  return (
    <SearchContext.Provider value={{ searchTermCtx, setSearchTerm }}>
      {children}
    </SearchContext.Provider>
  );
};